import { httpService } from '@/api/v1/http.service'
import { clientErrorsMapper } from '@/constants/invalid-status-error'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useActivateStudent = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { id: string }) =>
      httpService.panel.panelStudentsUnblockCreate(data.id),
    onSuccess,
    onError,
    clientErrorsMapper: clientErrorsMapper()
  })

export default useActivateStudent
